export default {"src":"/_next/static/media/icon_navigation_close.b2886b42.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};